import { render, staticRenderFns } from "./SMSF.vue?vue&type=template&id=32c7f4d4"
import script from "./SMSF.vue?vue&type=script&lang=js"
export * from "./SMSF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports